import { useState, useEffect } from 'react'

import './Form.css'

export default function Form() {
    const [success, setSuccess] = useState(false);
  
    useEffect(() => {
      if ( window.location.search.includes('success=true') ) {
        setSuccess(true);
      }
    }, []);
  
    return (
      <div className='contactForm'>
        {success && (
            <h4 style={{ color: "green", margin: "20px 0px" }}>Thanks for your message! </h4>
          )}
        <div>
            <form name="contact" 
            method="POST" 
            data-netlify="true" 
            action="/contact/?success=true">
                <input type="hidden" name="form-name" value="contact" />
                <p>
                    <label htmlFor="name">Name</label>
                    <input type="text" id="name" name="name" />
                </p>
                <p>
                    <label htmlFor="email">Email</label>
                    <input type="text" id="email" name="email" />
                </p>
                <p>
                    <label htmlFor="message">Message</label>
                    <textarea id="message" name="message"></textarea>
                </p>
                <p>
                    <button type="submit">Send</button>
                </p>
            </form>
        </div>
      </div>
    );
  }